import React, { memo, useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import useAdminApplicationDetailStore from "@/store/useAdminApplicationDetailStore";
import { Dialog, Alert } from "iron-man";
import { useTranslation } from "react-i18next";
import "./index.css";
import useModalStore from "@/store/useModalStore";
import { isProduction } from "@/setting";

/**
 * @description 接收props为
 *              open 弹窗开关状态； aid preauth申请单id；setOpenClickReleaseLimitDialog关闭弹窗函数
 *               
 */
const ReleaseLimitDialogContent = memo((props) => {
  const { requestReleaseLimit, ManualReleaseLimit, admGetPreAuthForm } = useAdminApplicationDetailStore();
  const { t } = useTranslation();
  const { openModalInfo } = useModalStore.getState();
  //限定antd的日期只能选今天及之后的日期。
  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day");
  };
  const { releaseCardLimitDate } = requestReleaseLimit; 
  const { open, setOpenClickReleaseLimitDialog, aid } = props;
  /*--Alert success- */
  const alertSuccess = () => {
    Alert({
      type: "success",
      content: t("translation:admin.releaselimit.successMessage"),
    });
  };
  const [selectDate, setSelectDate] = useState(releaseCardLimitDate); //设置初始值。

  const handleSelectDate = (val, dateStr) => {
    setSelectDate(dateStr);
  };

  const [isOpen, setIsOpen] = useState(open);
  const onCancel = () => {
    setIsOpen(false);
    setOpenClickReleaseLimitDialog(false);
  };
  const onClose = () => {
    setIsOpen(false);
    setOpenClickReleaseLimitDialog(false);
  };
  const onOk = async () => {
    setIsOpen(false);
    setOpenClickReleaseLimitDialog(false);
    const res = await ManualReleaseLimit(aid, selectDate);
    if (res?.code === 4) {
      if (res?.errors?.find((item) => (item.errorCode = 111001))) {
        openModalInfo({
          id: isProduction ? "pre_auth_error_unLimit" : "pre_auth_uat_error_unLimit",
          // title: i18n.t("error:unauthorized_signin.title"),
          text: t("translation:admin.releaselimit.error111001"), //tbc wording
        });
      }
    }
    if (res?.code == 0 && res?.success === true) {
      admGetPreAuthForm(aid);
      alertSuccess()//tbc alert wording
    }
  };
  return (
    <Dialog okDisabled={!selectDate} title={t("translation:admin.releaselimit.dialogTitile")} okTxt={t("confirm")} cancelTxt={t("cancel")} isOpen={isOpen} onCancel={onCancel} onClose={onClose} onOk={onOk}>
      <DatePicker disabledDate={disabledDate} className="custom-antd-release_limit_date" value={selectDate ? dayjs(selectDate) : null} onChange={handleSelectDate} placeholder="YYYY-MM-DD" />
    </Dialog>
  );
});

export default ReleaseLimitDialogContent;
